import { useHover } from '@mantine/hooks';
import React, { useEffect } from 'react';
import { RowContentProps } from '../types';

export function RowContent(props: RowContentProps) {
  const { children, setHovered, index, isParentMounted, ...rest } = props;

  const { ref, hovered } = useHover();
  useEffect(() => {
    if (!isParentMounted()) return;
    setHovered({
      [index]: hovered,
    });

    () => {
      if (!isParentMounted()) return;
      setHovered({
        [index]: false,
      });
    };
  }, [hovered]);
  return (
    <div className="Table_content" ref={ref} {...rest}>
      {children}
    </div>
  );
}
